import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralDropdownsTriggersTriggerStatic from 'lumen/components/general/dropdowns/triggers/trigger-static';
import type { TransactionMappingHierarchyCategory } from 'lumen/models';
import type {
  Category,
  SubCategory,
} from 'lumen/utils/constants/transaction-mapping/constants';

interface SettingsTransactionMappingDropdownMappingSignature {
  Args: {
    hierarchyCategories: TransactionMappingHierarchyCategory[];
    onCategorySelect: (
      categoryId: Category,
      subCategoryId: SubCategory,
    ) => void;
  };
}

export default class SettingsTransactionMappingDropdownMapping extends Component<SettingsTransactionMappingDropdownMappingSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get categoryOptions() {
    return this.args.hierarchyCategories.map((category) => {
      if (category.id === 'unmapped' || !category.subCategories.length) {
        return {
          id: category.id,
          label: category.translatedCategory,
        };
      }

      return {
        groupName: category.translatedCategory,
        unsafe_isCollapsed: true,

        options: category.subCategories.map((subCategory) => ({
          id: subCategory.id,
          groupId: category.id,
          label: subCategory.translatedSubCategory,
        })),
      };
    });
  }

  @action onCategorySelect(
    option:
      | { id: Category; label: string }
      | { groupId: Category; id: SubCategory; label: string },
  ): void {
    if (option.id === 'unmapped') {
      this.args.onCategorySelect('unmapped', 'unmapped');
    }

    if ('groupId' in option) {
      this.args.onCategorySelect(option.groupId, option.id);
    }
  }

  <template>
    {{#let
      (component
        GeneralDropdownsTriggersTriggerStatic
        buttonType="secondary"
        isTriggerSmall=true
        label=(t "settings.transaction_mapping.map_to_category")
      )
      as |triggerComponent|
    }}
      <PrismComboSelectInput
        @onChange={{this.onCategorySelect}}
        @options={{this.categoryOptions}}
        @unsafe_collapsibleGroupBackLabel={{t
          "settings.pms_mapping.back_to_categories"
        }}
        @unsafe_triggerComponent={{triggerComponent}}
        data-test-id="dropdown-mapping"
      />
    {{/let}}
  </template>
}
